import { IStoreState } from "interfaces/storeState";
import { TicketSelectorsNames } from "store/entities/tickets/actions";
import { createRequestFetchingSelector } from "store/requests/selectors";

export const isTicketRatingSending = (state: IStoreState): boolean =>
  createRequestFetchingSelector([TicketSelectorsNames.SEND_RATING])(state);
